<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZwRIjq/tc-custom/9781398448629.jpg?1705056298022" alt="This image is the cover for the book Olivia Taylor Fashion Dreams"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Olivia Taylor Fashion Dreams
      </h1>
      <p class="bookDescription body article font2">
        <p>Olivia Taylor, a stylish and creative genius, has a serendipitous and life-changing opportunity while navigating the convoluted world of haute couture. The 35-year-old British designer embarks on a career in fashion, which she discovers, she is ‘tailormade’ for. The dream job versus ruthless reality. Glamour versus drama. And to escort her through the conflict and cutthroat competition on this roller coaster journey, she depends on the loyal support of her precious friends and loving dog, Duke. <br/>Olivia is surprised and immediately curious when she stumbles across a miniature version of her namesake, a young orphan, nicknamed ‘Liv’. The little girl is captivating, with her lookalike features and natural charm. But something is about to turn her own world upside down in the realm of both work and romance. Olivia, through no design of her own, meets the handsome and mysterious Damien, which forces her to reconsider her notions of love. Will her whirlwind lifestyle even allow her to explore the possibility of a committed relationship? Only time and fate will tell. <br/>Her innate spirituality and sensitivity, coupled with her uncompromising self-belief will stand her in good stead, in pursuing her true calling in life. Adhering to those strong instincts, Olivia is able to seamlessly shift gears along the path of destiny and arrive at the best decision she has ever made, regardless of the extent to which her project threatens to tie her up in knots…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dolly Lloyd
      </h2>
      
      <p class="authorDescription body article">Dolly Lloyd is a Moldovan-born fashion designer who discovered her passion for fashion at the tender age of six, when her grandmother introduced her to sewing. Post attending school, she completed a degree in fashion at Northumbria University. Having honed her design skills working for various fashion brands, she finally created her own eponymous label under the name Teo Lloyd and opened a prestigious high street boutique in London. Her in-depth knowledge of the industry and insight into luxury brands has inspired her first novel in a forthcoming series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f8e2eff2